import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTE_INSTITUTION_UNIT, ROUTE_INSTITUTION_UNIT_EDIT, ROUTE_INSTITUTION_UNIT_ADD } from 'config/routes';
import { relativePath } from 'utils/navigation/relativePath';
import { NotFoundView } from 'views/Errors/NotFound.view';
import { UnitAdd } from 'views/Panel/Institutions/Unit/UnitAdd/UnitAdd.view';
import { UnitEdit } from 'views/Panel/Institutions/Unit/UnitEdit/UniteEdit.view';

export const Unit: React.FC = () => {
  return (
    <Routes>
      <Route path={relativePath(ROUTE_INSTITUTION_UNIT_ADD, ROUTE_INSTITUTION_UNIT)} element={<UnitAdd />} />
      <Route path={relativePath(`${ROUTE_INSTITUTION_UNIT_EDIT}/*`, ROUTE_INSTITUTION_UNIT)} element={<UnitEdit />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};
